import {
  Video,
  Radio,
  ClipboardCheck,
  NotebookPen,
  BookOpen,
  PlayCircle,
} from "lucide-react";
import { FEATURES } from "../data/content";
import { Reveal, Stagger, StaggerItem } from "./Reveal";

const ICONS = {
  Video,
  Radio,
  ClipboardCheck,
  NotebookPen,
  BookOpen,
  PlayCircle,
};

const toneClasses = {
  light: "bg-white border border-black/5 text-[#111827]",
  dark: "bg-[#0a0a0a] text-white",
  green: "bg-[#58cc02] text-white",
};

const iconWrap = {
  light: "bg-[#e5f7d6] text-[#46a302]",
  dark: "bg-white/10 text-[#8ee85a]",
  green: "bg-white/20 text-white",
};

const Features = () => (
  <section
    id="whats-inside"
    data-testid="features-section"
    className="relative bg-[#f8f9fa] py-24 md:py-32"
  >
    <div className="max-w-7xl mx-auto px-5 md:px-8">
      <Reveal>
        <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#58cc02]">
          Everything you get
        </p>
        <h2 className="font-display font-extrabold text-4xl md:text-6xl tracking-tight mt-4 text-[#111827] max-w-3xl">
          16 sessions. Zero fluff. Built to actually finish.
        </h2>
      </Reveal>

      <Stagger className="grid grid-cols-1 md:grid-cols-12 gap-6 mt-14">
        {FEATURES.map((f) => {
          const Icon = ICONS[f.icon];
          return (
            <StaggerItem key={f.title} className={f.span}>
              <div
                data-testid={`feature-${f.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className={`group h-full rounded-3xl p-8 md:p-10 transition-transform duration-300 hover:-translate-y-2 shadow-[0_8px_30px_rgb(0,0,0,0.04)] ${toneClasses[f.tone]}`}
              >
                <div
                  className={`h-14 w-14 rounded-2xl flex items-center justify-center ${iconWrap[f.tone]}`}
                >
                  <Icon className="h-7 w-7" />
                </div>
                <h3 className="font-display font-extrabold text-2xl md:text-3xl mt-6 tracking-tight">
                  {f.title}
                </h3>
                <p
                  className={`mt-3 text-base md:text-lg leading-relaxed ${
                    f.tone === "light" ? "text-[#4b5563]" : "text-white/80"
                  }`}
                >
                  {f.desc}
                </p>
              </div>
            </StaggerItem>
          );
        })}
      </Stagger>
    </div>
  </section>
);

export default Features;
